import { LoginPayload, NewAccountPayload } from '@dev/ee-api/ee-api-models';
import { connect, useSelector } from 'react-redux';

import React from 'react';
import { Registration as RegisterModule } from '@dev/ee-modules';
import { compose } from 'react-recompose';
import { isCustomBranding } from '@/services/Secuirty';
import { push } from 'redux-first-history';
import { useIntercom } from 'react-use-intercom';
import { useLocation } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { useConfigProductCode } from '@/services/hooks/useConfigProductCode';
import { useMobile } from '../../services/hooks/useMobile';
import { getLocationOrigin } from '../../services/tools/getLocationOrigin';
import { getConfigStore } from '../../store/config/types';
import { ApplicationState as State } from '../../store';
import { RegisterProps } from './RegisterInterface';
import Auth from '../../services/Authentication';
import { HomePaths } from '../../services/dictionaries/Paths';
import { CreateAccount, CreateAccountWithGoogle } from '../../store/account/actions';

const mapState = (state: State, ownProps: RegisterProps): RegisterProps => ({
    ...ownProps,
    account: state.account,
});

const dispatchProps = {
    Push: push,
    CreateAccount,
    CreateAccountWithGoogle,
};

interface DispatchProps {
    Push(url: string): void;
    CreateAccount(params: NewAccountPayload): any;
    CreateAccountWithGoogle(params: LoginPayload): any;
}

type ExtendedProps = RegisterProps & DispatchProps;

export const Register = (props: ExtendedProps): JSX.Element => {
    const { show } = useIntercom() || {};
    const { isStandalone, routerBasePath, bootedAsChild } = useSelector(getConfigStore);
    const isMobile = useMobile();
    const location = useLocation();
    const productCode = useConfigProductCode();

    const launchIntercom = () => {
        !isCustomBranding() && show();
    };
    const DashboardUrl = getLocationOrigin({ isStandalone, bootedAsChild, routerBasePath });

    return (
        <RegisterModule
            paths={HomePaths}
            launchIntercom={launchIntercom}
            GOOGLEAPIKEY={GOOGLEAPIKEY}
            RECAPTCHAKEY={RECAPTCHAKEY}
            isMobile={isMobile}
            isAuthenticated={Auth.isAuthenticated()}
            DashboardUrl={DashboardUrl}
            productCode={productCode}
            location={location}
            {...props}
        />
    );
};

export default compose(withTranslation(), connect<RegisterProps, DispatchProps>(mapState, dispatchProps))(Register);
